// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-n_fH","advertDetailContacts__header":"c-n_fJ"};